var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJdSiteReliability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1463 15.4432L3.59111 18.7853L3.01306 9.90297C2.75721 6.06358 6.2918 3.00003 10.7645 3.00003H62.8831C65.7828 2.99008 68.6635 5.36732 69.3932 8.33141L71.1463 15.4432Z",
    fill: "#434254",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.814 45.7606L15.5025 56.8212C10.4328 57.8059 5.92219 54.623 5.60948 49.789L3.59106 18.7854L71.1462 15.4434L76.775 38.2509C77.6468 41.782 75.9127 45.1638 72.814 45.7606Z",
    fill: "#434254",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3045 14.9824L5.57513 18.2007L5.01271 9.64731C4.76377 5.95012 8.20283 3.00003 12.5547 3.00003H63.2646C66.086 2.99045 68.8888 5.27964 69.5988 8.13395L71.3045 14.9824Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9271 44.1768L17.1646 54.8278C12.2319 55.776 7.84319 52.711 7.53893 48.056L5.57507 18.2007L71.3044 14.9824L76.7811 36.9453C77.6293 40.3455 75.9421 43.6021 72.9271 44.1768Z",
    fill: "white",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4305 12.7794C11.2177 12.856 9.27229 11.4097 9.13399 9.55153C8.99569 7.71252 10.6645 6.21832 12.8496 6.19916C14.9979 6.17043 16.8511 7.588 17.0263 9.36955C17.2107 11.1703 15.6156 12.7028 13.4305 12.7794Z",
    fill: "#434254",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0286 12.4345C20.9633 12.5112 19.1193 11.1032 18.9257 9.32162C18.7413 7.54965 20.2626 6.11292 22.291 6.08418C24.2917 6.06503 26.0619 7.42513 26.2832 9.14921C26.5045 10.8829 25.057 12.3675 23.0286 12.4345Z",
    fill: "#434254",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9811 12.1185C30.0541 12.1856 28.2839 10.8351 28.0626 9.11099C27.8413 7.40606 29.2151 6.00764 31.1144 5.98849C32.9861 5.96933 34.6825 7.28155 34.9315 8.94816C35.1804 10.6243 33.8712 12.0515 31.9811 12.1185Z",
    fill: "#434254",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.127 10.9403L45.1104 11.6491C43.377 11.7066 41.7266 10.4231 41.45 8.78524C41.1734 7.16652 42.3628 5.84473 44.0685 5.82557L63.8638 5.59569C65.2929 5.57654 66.7128 6.7355 67.0632 8.18181C67.4135 9.64728 66.5561 10.8829 65.1085 10.9308L65.127 10.9403Z",
    fill: "white",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0975 20.0194C49.5188 19.6664 55.4704 24.17 56.7513 30.2581C58.0748 36.5787 54.0017 42.7271 47.2474 43.8293C40.0576 45.0004 33.0642 40.0146 32.1078 32.8845C31.1856 26.0472 36.2919 20.3897 43.0975 20.0108V20.0194Z",
    fill: "#FFEBAF",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5075 22.3445C48.6565 22.0086 53.4383 25.6081 54.4288 30.5079C55.4535 35.554 52.1489 40.3849 46.7865 41.1943C41.1593 42.0468 35.7285 38.1374 34.9258 32.5918C34.1232 27.0462 38.1109 22.6975 43.499 22.3445H43.5075Z",
    fill: "#FFEBAF",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8575 24.3336C47.8965 24.0322 51.6707 26.8566 52.4307 30.7231C53.2077 34.6756 50.5862 38.4042 46.4107 38.9898C42.2351 39.5753 37.9144 36.5873 37.274 32.3333C36.6506 28.1914 39.6649 24.6436 43.8575 24.3249V24.3336Z",
    fill: "#FFEBAF",
    stroke: "#434254",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3557 31.877C41.5863 31.5928 42.0303 31.5498 42.3377 31.7737L43.6613 32.7123C43.7637 32.7812 43.9089 32.7726 43.9772 32.6778L47.1452 28.7167C47.3586 28.4498 47.777 28.4153 48.0759 28.6306C48.3748 28.8459 48.4431 29.242 48.2381 29.5003L44.7799 33.892C44.4383 34.3312 43.7723 34.4087 43.2941 34.0642L41.5094 32.7984C41.1935 32.5745 41.1252 32.1612 41.3643 31.8856L41.3557 31.877Z",
    fill: "#434254",
    stroke: "#434254",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdSiteReliability);
export default __webpack_public_path__ + "static/media/jd-site-reliability.491ac72be0677b7ea36adde0f4640acd.svg";
export { ForwardRef as ReactComponent };